export default __webpack_public_path__ + "static/media/AtomsAndCompounds _00.b33eaf92.png";